import { render, staticRenderFns } from "./SortDownSolid.vue?vue&type=template&id=655d9ab7&scoped=true"
var script = {}
import style0 from "./SortDownSolid.vue?vue&type=style&index=0&id=655d9ab7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d9ab7",
  null
  
)

export default component.exports